import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Briefcase, Building2, Layers } from "lucide-react";
import { RolesManager } from "./RolesManager";
import { IndustriesManager } from "./IndustriesManager";
import { TiersManager } from "./TiersManager";
import { CatalogMaintenance } from "./CatalogMaintenance";
import { RateIncrease } from "./RateIncrease";

const subTabCls =
  "data-[state=active]:bg-[#1E6BFF] data-[state=active]:text-white text-white/60 rounded-md px-4 py-1.5 flex items-center gap-2";

export const RoleIntelligence = ({ token }) => {
  const [tab, setTab] = useState("roles");
  const [version, setVersion] = useState(0);

  return (
    <div data-testid="rims-role-intelligence">
      <div className="mb-6">
        <h2 className="text-white text-lg font-semibold">Role Intelligence Library</h2>
        <p className="text-white/45 text-sm mt-1">
          Manage the roles, industries, and experience tiers that power TeamBuilder AI
          recommendations. Changes apply immediately to future assessments.
        </p>
      </div>

      <CatalogMaintenance token={token} onApplied={() => setVersion((v) => v + 1)} />
      <RateIncrease token={token} onApplied={() => setVersion((v) => v + 1)} />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-[#0A0F1E] border border-white/10 h-auto p-1 mb-6">
          <TabsTrigger value="roles" data-testid="rims-tab-roles" className={subTabCls}>
            <Briefcase size={15} /> Roles
          </TabsTrigger>
          <TabsTrigger value="industries" data-testid="rims-tab-industries" className={subTabCls}>
            <Building2 size={15} /> Industries
          </TabsTrigger>
          <TabsTrigger value="tiers" data-testid="rims-tab-tiers" className={subTabCls}>
            <Layers size={15} /> Experience Tiers
          </TabsTrigger>
        </TabsList>

        <TabsContent value="roles">
          <RolesManager key={`roles-${version}`} token={token} />
        </TabsContent>
        <TabsContent value="industries">
          <IndustriesManager key={`inds-${version}`} token={token} />
        </TabsContent>
        <TabsContent value="tiers">
          <TiersManager key={`tiers-${version}`} token={token} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
